import React, { useState, useEffect } from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';

const destinations = [
  { flag: '🇬🇧', country: 'United Kingdom', time: '15–25 working days', fee: '₹12,400', type: 'Tourist / Business' },
  { flag: '🇺🇸', country: 'United States', time: '30–60 working days', fee: '₹14,500', type: 'Tourist / Business' },
  { flag: '🇨🇦', country: 'Canada', time: '20–40 working days', fee: '₹9,800', type: 'Tourist / Student' },
  { flag: '🇦🇺', country: 'Australia', time: '15–30 working days', fee: '₹10,200', type: 'Tourist / Business' },
  { flag: '🇪🇺', country: 'Schengen (Europe)', time: '10–15 working days', fee: '₹7,500', type: '26 Countries' },
  { flag: '🇦🇪', country: 'UAE / Dubai', time: '2–5 working days', fee: '₹4,200', type: 'Tourist / Transit' },
  { flag: '🇸🇬', country: 'Singapore', time: '5–10 working days', fee: '₹3,800', type: 'Tourist / Business' },
  { flag: '🇯🇵', country: 'Japan', time: '5–10 working days', fee: '₹5,500', type: 'Tourist' },
  { flag: '🇹🇭', country: 'Thailand', time: '3–5 working days', fee: '₹2,800', type: 'Tourist' },
];

const checklist = [
  { item: 'Valid Passport (6+ months validity)', status: 'verified' },
  { item: 'Passport-size photographs (white background)', status: 'verified' },
  { item: 'Bank statements (last 6 months)', status: 'uploaded' },
  { item: 'Employment letter / Business proof', status: 'uploaded' },
  { item: 'Travel itinerary and flight tickets', status: 'missing' },
  { item: 'Hotel booking confirmation', status: 'missing' },
  { item: 'Travel insurance', status: 'pending' },
  { item: 'Income tax returns (last 3 years)', status: 'pending' },
];

const trackingSteps = [
  { label: 'Consultation', done: true },
  { label: 'Documents Submitted', done: true },
  { label: 'Documents Verified', done: true },
  { label: 'Application Prepared', done: true },
  { label: 'Application Submitted', active: true },
  { label: 'Decision Pending', done: false },
  { label: 'Visa Issued', done: false },
];

const getStatusStyle = (status) => {
  if (status === 'verified') return { color: 'var(--success, #16865B)', bg: 'rgba(22,134,91,0.1)', label: '✓ Verified' };
  if (status === 'uploaded') return { color: 'var(--royal, #0f2744)', bg: 'rgba(244,123,32,0.1)', label: '↑ Uploaded' };
  if (status === 'missing') return { color: 'var(--error, #d64545)', bg: 'rgba(214,69,69,0.1)', label: '! Missing' };
  return { color: 'var(--gold-dark, #d96614)', bg: 'rgba(244,123,32,0.1)', label: '○ Pending' };
};

export default function Visa() {
  const [selected, setSelected] = useState(null);
  const [view, setView] = useState('list');
  const [isDesktop, setIsDesktop] = useState(
    typeof window !== 'undefined' ? window.innerWidth >= 768 : true
  );

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth >= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const sectionLabelStyle = {
    fontSize: '13px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: 'var(--gold, #F47B20)',
    marginBottom: '12px',
    fontFamily: 'Manrope, sans-serif',
  };

  const btnGoldStyle = {
    background: 'var(--gold, #F47B20)',
    color: 'var(--navy, #0a192f)',
    fontWeight: 700,
    cursor: 'pointer',
    border: 'none',
    fontFamily: 'Manrope, sans-serif',
  };

  return (
    <>
      <Nav />
      <div style={{ minHeight: '100vh', background: 'var(--bg, #f8fafc)', fontFamily: 'Manrope, sans-serif' }}>
        {/* Hero */}
        <div
          style={{
            background: 'var(--navy, #0a192f)',
            paddingTop: '80px',
            paddingBottom: '48px',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              opacity: 0.2,
              background: 'radial-gradient(circle at 70% 50%, var(--royal, #0f2744) 0%, transparent 60%)',
            }}
          />
          <div
            style={{
              position: 'relative',
              zIndex: 10,
              maxWidth: '1280px',
              margin: '0 auto',
              padding: '32px 24px',
              textAlign: 'center',
              boxSizing: 'border-box',
            }}
          >
            <p style={sectionLabelStyle}>Visa Consultancy</p>
            <h1
              style={{
                fontSize: isDesktop ? '48px' : '36px',
                fontWeight: 800,
                color: '#ffffff',
                marginBottom: '16px',
                marginTop: 0,
                fontFamily: 'Manrope, sans-serif',
              }}
            >
              Visa Assistance Made Simple.
            </h1>
            <p
              style={{
                color: 'rgba(255,255,255,0.7)',
                fontSize: '16px',
                maxWidth: '576px',
                margin: '0 auto 24px auto',
                lineHeight: 1.6,
              }}
            >
              Professional visa guidance and document assistance for Indian travellers.
            </p>

            <div
              style={{
                maxWidth: '448px',
                margin: '0 auto',
                display: 'flex',
                gap: '8px',
                flexDirection: isDesktop ? 'row' : 'column',
              }}
            >
              <input
                placeholder="Where are you planning to travel?"
                style={{
                  flex: 1,
                  padding: '12px 16px',
                  borderRadius: '12px',
                  fontSize: '14px',
                  outline: 'none',
                  background: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.2)',
                  color: '#ffffff',
                  fontFamily: 'Manrope, sans-serif',
                  boxSizing: 'border-box',
                }}
              />
              <button
                style={{
                  ...btnGoldStyle,
                  padding: '12px 20px',
                  borderRadius: '12px',
                  fontSize: '14px',
                }}
              >
                Search
              </button>
            </div>

            {/* View toggle */}
            <div
              style={{
                display: 'flex',
                gap: '8px',
                justifyContent: 'center',
                marginTop: '20px',
                flexWrap: 'wrap',
              }}
            >
              {[
                { key: 'list', label: 'All Destinations' },
                { key: 'detail', label: 'UK Visa Detail' },
                { key: 'tracker', label: 'Track Application' },
              ].map((v) => (
                <button
                  key={v.key}
                  onClick={() => setView(v.key)}
                  style={{
                    padding: '6px 16px',
                    borderRadius: '9999px',
                    fontSize: '12px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    border: 'none',
                    transition: 'all 0.2s',
                    background: view === v.key ? 'var(--gold, #F47B20)' : 'rgba(255,255,255,0.1)',
                    color: view === v.key ? 'var(--navy, #0a192f)' : 'rgba(255,255,255,0.7)',
                    fontFamily: 'Manrope, sans-serif',
                  }}
                >
                  {v.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '40px 24px', boxSizing: 'border-box' }}>
          {view === 'list' && (
            <>
              {/* Visa Type Cards */}
              <div
                style={{
                  display: 'flex',
                  gap: '12px',
                  marginBottom: '32px',
                  overflowX: 'auto',
                  paddingBottom: '4px',
                }}
              >
                {['Tourist Visa', 'Business Visa', 'Student Visa', 'Family Visa', 'Transit Visa'].map((t) => (
                  <button
                    key={t}
                    style={{
                      flexShrink: 0,
                      padding: '8px 16px',
                      borderRadius: '9999px',
                      fontSize: '13px',
                      fontWeight: 600,
                      cursor: 'pointer',
                      background: 'var(--white, #ffffff)',
                      border: '1px solid var(--border, #e2e8f0)',
                      color: 'var(--text-secondary, #4a5568)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    {t}
                  </button>
                ))}
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isDesktop ? 'repeat(3, 1fr)' : '1fr',
                  gap: '16px',
                }}
              >
                {destinations.map((d, i) => (
                  <div
                    key={d.country}
                    onClick={() => {
                      setSelected(i);
                      setView('detail');
                    }}
                    style={{
                      borderRadius: '12px',
                      padding: '20px',
                      cursor: 'pointer',
                      background: 'var(--white, #ffffff)',
                      border: selected === i ? '1.5px solid var(--royal, #0f2744)' : '1px solid var(--border, #e2e8f0)',
                      boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                        <span style={{ fontSize: '30px' }}>{d.flag}</span>
                        <div>
                          <h3
                            style={{
                              fontWeight: 700,
                              fontSize: '15px',
                              margin: 0,
                              fontFamily: 'Manrope, sans-serif',
                              color: 'var(--navy, #0a192f)',
                            }}
                          >
                            {d.country}
                          </h3>
                          <p style={{ fontSize: '12px', margin: '2px 0 0 0', color: 'var(--text-muted, #718096)' }}>
                            {d.type}
                          </p>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          fontSize: '13px',
                          marginBottom: '16px',
                          borderTop: '1px solid var(--border, #e2e8f0)',
                          paddingTop: '12px',
                        }}
                      >
                        <div>
                          <p
                            style={{
                              fontWeight: 600,
                              color: 'var(--text-muted, #718096)',
                              fontSize: '11px',
                              margin: 0,
                              textTransform: 'uppercase',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            PROCESSING TIME
                          </p>
                          <p
                            style={{
                              color: 'var(--navy, #0a192f)',
                              fontFamily: 'Manrope, sans-serif',
                              fontWeight: 600,
                              margin: '2px 0 0 0',
                            }}
                          >
                            {d.time}
                          </p>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                          <p
                            style={{
                              fontWeight: 600,
                              color: 'var(--text-muted, #718096)',
                              fontSize: '11px',
                              margin: 0,
                              textTransform: 'uppercase',
                              fontFamily: 'Manrope, sans-serif',
                            }}
                          >
                            GOVT. FEE
                          </p>
                          <p
                            style={{
                              color: 'var(--navy, #0a192f)',
                              fontFamily: 'Manrope, sans-serif',
                              fontWeight: 600,
                              margin: '2px 0 0 0',
                            }}
                          >
                            {d.fee}
                          </p>
                        </div>
                      </div>
                    </div>

                    <button
                      style={{
                        width: '100%',
                        padding: '8px 0',
                        borderRadius: '8px',
                        fontSize: '12px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        background: 'var(--bg, #f8fafc)',
                        border: '1.5px solid var(--navy, #0a192f)',
                        color: 'var(--navy, #0a192f)',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      Check Requirements
                    </button>
                  </div>
                ))}
              </div>
            </>
          )}

          {view === 'detail' && (
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: isDesktop ? '2fr 1fr' : '1fr',
                gap: '24px',
              }}
            >
              <div>
                <div
                  style={{
                    borderRadius: '12px',
                    padding: '24px',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
                    <span style={{ fontSize: '30px' }}>🇬🇧</span>
                    <div>
                      <h2
                        style={{
                          fontSize: '20px',
                          fontWeight: 800,
                          margin: 0,
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #0a192f)',
                        }}
                      >
                        UK Tourist Visa Assistance
                      </h2>
                      <p style={{ fontSize: '13px', margin: '2px 0 0 0', color: 'var(--text-muted, #718096)' }}>
                        Standard Visitor Visa · 6 months
                      </p>
                    </div>
                  </div>

                  {[
                    {
                      title: 'Overview',
                      content:
                        'The UK Standard Visitor Visa allows Indian passport holders to visit the United Kingdom for tourism, family visits, or short business trips for up to 6 months. Aerova provides end-to-end application support.',
                    },
                    {
                      title: 'Eligibility',
                      content:
                        'Valid Indian passport, proof of financial sufficiency (min. ₹2 lakh in savings), genuine intent to return to India, ties to India (employment/business/property).',
                    },
                    {
                      title: 'Processing Time',
                      content:
                        '15–25 working days (Standard). Priority processing available: 5–10 working days at additional cost.',
                    },
                    {
                      title: 'How Aerova Helps',
                      content:
                        'Document review and gap analysis, appointment booking, cover letter drafting, mock interview preparation, and real-time application tracking.',
                    },
                  ].map((section) => (
                    <div
                      key={section.title}
                      style={{
                        marginBottom: '20px',
                        paddingBottom: '20px',
                        borderBottom: '1px solid var(--border, #e2e8f0)',
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: 700,
                          fontSize: '14px',
                          marginBottom: '8px',
                          marginTop: 0,
                          fontFamily: 'Manrope, sans-serif',
                          color: 'var(--navy, #0a192f)',
                        }}
                      >
                        {section.title}
                      </h3>
                      <p
                        style={{
                          fontSize: '13px',
                          lineHeight: 1.6,
                          margin: 0,
                          color: 'var(--text-secondary, #4a5568)',
                        }}
                      >
                        {section.content}
                      </p>
                    </div>
                  ))}

                  <div style={{ display: 'flex', gap: '12px', flexWrap: isDesktop ? 'nowrap' : 'wrap' }}>
                    <button
                      style={{
                        ...btnGoldStyle,
                        flex: 1,
                        padding: '12px 0',
                        borderRadius: '12px',
                        fontSize: '14px',
                      }}
                    >
                      Start Visa Consultation
                    </button>
                    <button
                      style={{
                        padding: '12px 20px',
                        borderRadius: '12px',
                        fontSize: '14px',
                        fontWeight: 700,
                        cursor: 'pointer',
                        background: 'transparent',
                        border: '1.5px solid var(--navy, #0a192f)',
                        color: 'var(--navy, #0a192f)',
                        fontFamily: 'Manrope, sans-serif',
                      }}
                    >
                      Talk to Expert
                    </button>
                  </div>
                </div>
              </div>

              {/* Document Checklist */}
              <div>
                <div
                  style={{
                    borderRadius: '12px',
                    padding: '20px',
                    background: 'var(--white, #ffffff)',
                    border: '1px solid var(--border, #e2e8f0)',
                    boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                  }}
                >
                  <h3
                    style={{
                      fontWeight: 700,
                      fontSize: '14px',
                      marginBottom: '16px',
                      marginTop: 0,
                      fontFamily: 'Manrope, sans-serif',
                      color: 'var(--navy, #0a192f)',
                    }}
                  >
                    Document Checklist
                  </h3>
                  {checklist.map((item) => {
                    const style = getStatusStyle(item.status);
                    return (
                      <div
                        key={item.item}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          padding: '10px 0',
                          borderBottom: '1px solid var(--border, #e2e8f0)',
                        }}
                      >
                        <p
                          style={{
                            fontSize: '12px',
                            flex: 1,
                            paddingRight: '12px',
                            margin: 0,
                            color: 'var(--text-secondary, #4a5568)',
                          }}
                        >
                          {item.item}
                        </p>
                        <span
                          style={{
                            fontSize: '10px',
                            fontWeight: 700,
                            padding: '2px 8px',
                            borderRadius: '4px',
                            flexShrink: 0,
                            background: style.bg,
                            color: style.color,
                            fontFamily: 'Manrope, sans-serif',
                          }}
                        >
                          {style.label}
                        </span>
                      </div>
                    );
                  })}
                  <button
                    style={{
                      width: '100%',
                      marginTop: '16px',
                      padding: '10px 0',
                      borderRadius: '8px',
                      fontSize: '13px',
                      fontWeight: 700,
                      cursor: 'pointer',
                      border: '1.5px dashed var(--border, #e2e8f0)',
                      color: 'var(--text-muted, #718096)',
                      background: 'transparent',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    + Upload Document
                  </button>
                </div>
              </div>
            </div>
          )}

          {view === 'tracker' && (
            <div style={{ maxWidth: '576px', margin: '0 auto' }}>
              <div
                style={{
                  borderRadius: '16px',
                  padding: '24px',
                  background: 'var(--white, #ffffff)',
                  border: '1px solid var(--border, #e2e8f0)',
                  boxShadow: 'var(--card-shadow, 0 4px 20px rgba(0,0,0,0.05))',
                }}
              >
                <h2
                  style={{
                    fontWeight: 800,
                    fontSize: '20px',
                    marginBottom: '4px',
                    marginTop: 0,
                    fontFamily: 'Manrope, sans-serif',
                    color: 'var(--navy, #0a192f)',
                  }}
                >
                  Application Tracker
                </h2>

                <div
                  style={{
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '12px',
                    marginBottom: '24px',
                    marginTop: '16px',
                    padding: '16px',
                    borderRadius: '12px',
                    background: 'var(--bg, #f8fafc)',
                    border: '1px solid var(--border, #e2e8f0)',
                  }}
                >
                  {[
                    { label: 'Application ID', value: 'ATV-2026-08734' },
                    { label: 'Applicant', value: 'Priya Sharma' },
                    { label: 'Visa Type', value: 'UK Tourist Visa' },
                    { label: 'Last Updated', value: '26 Aug 2026, 11:40 AM' },
                  ].map((info) => (
                    <div key={info.label}>
                      <p
                        style={{
                          fontSize: '10px',
                          fontWeight: 700,
                          textTransform: 'uppercase',
                          letterSpacing: '0.05em',
                          marginBottom: '2px',
                          marginTop: 0,
                          color: 'var(--text-muted, #718096)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        {info.label}
                      </p>
                      <p
                        style={{
                          fontSize: '13px',
                          fontWeight: 600,
                          margin: 0,
                          color: 'var(--navy, #0a192f)',
                          fontFamily: 'Manrope, sans-serif',
                        }}
                      >
                        {info.value}
                      </p>
                    </div>
                  ))}
                </div>

                <div style={{ position: 'relative', paddingLeft: '16px' }}>
                  {trackingSteps.map((step, i) => (
                    <div
                      key={step.label}
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        gap: '16px',
                        marginBottom: '20px',
                        position: 'relative',
                      }}
                    >
                      <div
                        style={{
                          width: '28px',
                          height: '28px',
                          borderRadius: '50%',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '11px',
                          fontWeight: 700,
                          flexShrink: 0,
                          position: 'relative',
                          zIndex: 10,
                          background: step.done
                            ? 'var(--success, #16865B)'
                            : step.active
                              ? 'var(--royal, #0f2744)'
                              : 'var(--border, #e2e8f0)',
                          color: step.done || step.active ? '#ffffff' : 'var(--text-muted, #718096)',
                          fontFamily: 'Manrope, sans-serif',
                          border: step.active ? '3px solid rgba(244,123,32,0.25)' : 'none',
                          boxSizing: 'border-box',
                        }}
                      >
                        {step.done ? '✓' : step.active ? '●' : '○'}
                      </div>

                      {i < trackingSteps.length - 1 && (
                        <div
                          style={{
                            position: 'absolute',
                            left: '13px',
                            top: '28px',
                            width: '2px',
                            height: '20px',
                            background: step.done ? 'var(--success, #16865B)' : 'var(--border, #e2e8f0)',
                          }}
                        />
                      )}

                      <div style={{ paddingTop: '2px' }}>
                        <p
                          style={{
                            fontWeight: 600,
                            fontSize: '14px',
                            margin: 0,
                            fontFamily: 'Manrope, sans-serif',
                            color: step.done
                              ? 'var(--success, #16865B)'
                              : step.active
                                ? 'var(--navy, #0a192f)'
                                : 'var(--text-muted, #718096)',
                          }}
                        >
                          {step.label}
                        </p>
                        {step.active && (
                          <p
                            style={{
                              fontSize: '12px',
                              marginTop: '2px',
                              marginBottom: 0,
                              color: 'var(--text-muted, #718096)',
                            }}
                          >
                            Application submitted to UK Visas & Immigration. Awaiting decision.
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>

                <div
                  style={{
                    marginTop: '16px',
                    padding: '16px',
                    borderRadius: '12px',
                    textAlign: 'center',
                    background: 'rgba(244,123,32,0.08)',
                    border: '1px solid rgba(244,123,32,0.2)',
                  }}
                >
                  <p
                    style={{
                      fontSize: '13px',
                      fontWeight: 600,
                      marginBottom: '4px',
                      marginTop: 0,
                      color: 'var(--navy, #0a192f)',
                      fontFamily: 'Manrope, sans-serif',
                    }}
                  >
                    Estimated Decision: 5–8 Sep 2026
                  </p>
                  <p style={{ fontSize: '12px', margin: 0, color: 'var(--text-muted, #718096)' }}>
                    Your consultant will notify you immediately upon decision.
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}